module.exports = __webpack_public_path__ + "1a877da21e91473698c10722e61c5e50.jpg";